module.exports = __webpack_public_path__ + "img/arrow-left.a15391ea.svg";